import { render, staticRenderFns } from "./ReportDocFiles.vue?vue&type=template&id=38902a34&"
import script from "./ReportDocFiles.vue?vue&type=script&lang=js&"
export * from "./ReportDocFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QItem,QSelect,QBtn,QIcon,QExpansionItem,QItemSection} from 'quasar'
component.options.components = Object.assign({QItem,QSelect,QBtn,QIcon,QExpansionItem,QItemSection}, component.options.components || {})
